




































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { goToOrdersLink } from '@/helpers/routing/links';
import type { Project } from '@/models/project';

@Component
export default class ProjectOrderTable extends Vue {
    @Prop({ required: true }) readonly selectedProject!: Project;

    get order() {
        if (this.selectedProject.order) {
            return this.selectedProject.order;
        } else if (this.selectedProject.parent_project && this.selectedProject.parent_project.order) {
            return this.selectedProject.parent_project.order;
        }
    }

    get filteredWorksheetPhases() {
        if (!this.order) {
            return [];
        }
        return this.order.worksheet_pm_phases.filter((worksheet) => {
            return worksheet.bim_targets_total + worksheet.bim_usecases_total + worksheet.delivery_objects_total !== 0;
        });
    }

    goToWorksheetPhase(orderId: number, orderWorksheetPhaseId: number) {
        goToOrdersLink(`/orders/worksheet/${orderId}/worksheet_pmphases/${orderWorksheetPhaseId}`, true);
    }
}
